import ModifyCustomerPointModal from './modify-customer-point-modal.vue'
export default ModifyCustomerPointModal
